<template>
  <div>
    <div class="ceiling">
      <home-top></home-top>
      <navicat :current="7" background="#FFFFFF"></navicat>
    </div>
    <!-- <div class="h-top"></div> -->
    <div class="content w-1400">
      <div class="bread-crumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/project-transaction' }">来料加工</el-breadcrumb-item>
          <el-breadcrumb-item>加工需求</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="title">加工需求</div>
      <div class="content-body">
        <!--        左侧详情-->
        <div class="body-left" v-loading="loading">
          <div class="top-tag ">
            <el-tag effect="dark" color="#3860F4">需求方</el-tag>
            <el-tag effect="plain" type="info">项目编号：{{ detailInfo.id }}</el-tag>
          </div>
          <div class="body-content-title">
            {{ detailInfo.title }}
          </div>
          <div class="need-info">详细描述:
            <span class="body-content-desc">{{ detailInfo.detile }}</span>
          </div>
          <div class="body-content">
            <table border="1" class="custom-table">
              <tr>
                <td>生产数量</td>
                <td>{{ detailInfo.product_number }}</td>
                <td>技术成熟度</td>
                <td v-if="detailInfo.technology == 3">产业化技术</td>
                <td v-if="detailInfo.technology == 1">小试技术</td>
                <td v-if="detailInfo.technology == 2">中试技术</td>
              </tr>
              <tr>
                <td>加工费用</td>
                <td>{{ detailInfo.processing_cost || '--' }}</td>
                <td>发布时间</td>
                <td>{{ detailInfo.created_at || '--' }}</td>
              </tr>
              <tr>
                <td>危险反应</td>
                <td>{{ detailInfo.is_danger ? '是' : '否' }}</td>
                <td>截止时间</td>
                <td>{{ detailInfo.end_time || '--' }}</td>
              </tr>
              <tr>
                <td>原料办证</td>
                <td>{{ detailInfo.is_cert ? '是' : '否' }}</td>
                <td>废水数量</td>
                <td>{{ detailInfo.wastewater_num || '--' }}</td>
              </tr>
              <tr>
                <td>废气数量</td>
                <td>{{ detailInfo.wastegas_num || '--' }}</td>
                <td>废固数量</td>
                <td>{{ detailInfo.waste_solids_num || '--' }}</td>
              </tr>
              <!-- 第6行 -->
              <tr>
                <td>设备要求</td>
                <td colspan="4">{{ detailInfo.equipment_requirement || '--' }}</td>
              </tr>

              <!-- 第7行 -->
              <tr>
                <td>详情</td>
                <td colspan="3">{{ detailInfo.detail || '--' }}</td>
              </tr>
            </table>
          </div>
          <div class="body-button-list">
            <el-button class="button-blue" @click="publishDemand">发布供需</el-button>
            <el-button class="button-yellow" @click="handleGetContact">免费获取联系方式</el-button>
            <el-button type="primary" class="info" plain @click="handleGuarantee">联系客服</el-button>
          </div>
          <div class="button-info">
            <div class="p-box">声明</div>
            <div class="desc-info">
              加工需求信息由化联网平台注册用户自主发布，本平台为其提供免费线上展示服务。尽管所有信息均经过严格审核，但鉴于化学化工技术的复杂性和专业性，本平台无法完全保证技术类信息的真实性、可靠性及有效性。
            </div>
          </div>
        </div>
        <!--        右侧表格-->
        <div class="body-right">
          <div class="right-title">最新供需</div>
          <div class="right-content">
            <need v-for="(item, index) in needList" :key="index" :data="item"></need>
          </div>
        </div>
      </div>
    </div>
    <!-- 联系客服 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
               :title="dialogTitle" :modal="false" top="20vh" :visible.sync="dialogVisible" width="30%"
               :before-close="handleClose">
      <span class="dialog-content" @click="copyText(dialogContent)">{{ dialogContent }} <i
          class="el-icon-copy-document"></i>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeTop from "../../../components/public/home-top.vue";
import Navicat from "../../../components/navicat/navicat.vue";
import Need from "../../../components/goods/need.vue";
import {proces_detail, proces_list} from "@/api/modules/home";
import {getMyCustomerService} from "@/api/modules/user";
import HomeFooter from "../../../components/public/home-footer.vue";

export default {
  name: "factory",
  components: {HomeFooter, Navicat, HomeTop, Need},
  data() {
    return {
      id: this.$route.query.id,
      detailInfo: {},
      dialogVisible: false,
      dialogTitle: '',
      dialogContent: '',
      needList: [],
      loading: false,
      kefu: '',
    }
  },
  computed: {
    configInfo() {
      return this.$store.state.config.config;
    },
  },
  created() {
    this.getList()
    this.getKefu()
  },
  watch: {
    '$route.query.id': {
      handler(newVal) {
        this.id = newVal;
        this.getDetail();
      },
      immediate: true,
    },
  },
  methods: {
    getKefu() {
      getMyCustomerService().then(res => {
        this.kefu = res.data.data.kefu.mobile
      })
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
    },
    // 联系客服
    handleGuarantee() {
      this.dialogVisible = true;
      this.dialogTitle = "联系客服";
      this.dialogContent = this.kefu;
    },
    // 免费获取联系方式
    handleGetContact() {
      this.dialogVisible = true;
      this.dialogTitle = "免费获取联系方式";
      this.dialogContent = this.detailInfo.people.mobile;
    },
    // 发布供需
    publishDemand() {
      this.$router.push({
        path: "/user/user-center",
      });
    },
    // 复制文本
    copyText(text) {
      this.$utils.copyText(text, this);
    },

    // 获取详情
    getDetail() {
      this.loading = true
      proces_detail(this.id).then(res => {
        this.detailInfo = res.data.data;
        this.loading = false
      })
    },
    getList() {
      // 需求方
      proces_list(2, {
        page: 1,
        limit: 3
      }).then((res) => {
        this.needList = res.data.data.data;
      });
    },

  }
};
</script>
<style scoped lang="scss">
.h-top {
  // height: 142px;
  height: 120px;
}

.content {
  padding-bottom: 40px;

  .bread-crumb {
    margin: 20px 0;
  }

  .title {
    font-weight: 800;
    font-size: var(--font-size-default-big);
    color: #00112B;
    padding-bottom: 20px;
    // line-height: 93px;
  }

  .content-body {
    display: flex;
    justify-content: space-between;

    .body-right {
      padding: 0 20px;
      box-sizing: border-box;
      width: 370px;
      background: #FFFFFF;
      padding-bottom: 20px;

      .right-title {
        font-weight: 800;
        line-height: 73px;
        font-size: var(--font-size-default-20);
        color: #00112B;
      }

      .right-content {
        display: flex;
        flex-direction: column;
        gap: 20px;
      }
    }

    .body-left {

      box-sizing: border-box;
      width: 1010px;
      background: #FFFFFF;
      padding: 32px 37px;

      .top-tag {
        display: flex;
        gap: 30px;
        align-items: center;
      }

      .body-content-title {
        font-weight: 800;
        font-size: var(--font-size-default-20);
        color: #00112B;
        padding: 20px 0 10px;

      }

      .need-info {
        font-weight: 400;
        font-size: 16px;
        color: #5F616C;
        line-height: 22px;
        margin-bottom: 20px;
      }

      .body-button-list {
        display: flex;
        justify-content: flex-end;
        gap: 20px;
        padding: 30px 0 30px;

        .button-blue {
          width: 214px;
          background: #387DF6;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #336ED2;
          color: #FFFFFF;
          //line-height: 60px;
          text-align: center;
        }

        .info {
          width: 214px;
          height: 40px;
        }

        .button-yellow {
          width: 216px;
          background: #F3AD3E;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #DFA544;
          text-align: center;
          //line-height: 60px;
          color: #FFFFFF;
        }
      }

      .button-info {
        padding: 0 33px;
        height: 111px;
        background: #F9FAFF;

        .p-box {
          font-weight: bold;
          font-size: var(--font-size-default-16);
          color: #5F616C;
          padding-top: 10px;
          padding-bottom: 5px;
          //line-height: 41px;
        }

        .desc-info {
          font-weight: 400;
          font-size: 16px;
          color: #5F616C;
          line-height: 22px;
        }
      }

      .custom-table {
        width: 100%;
        border-collapse: collapse;
        /* 关键：合并边框 */
        border-color: #F3F3F3;

        /* 新增样式规则 */
        td:nth-child(1),
        td:nth-child(3) {
          width: 179px;
          height: 50px;
          background: #F9FAFF;
          text-align: right;
          padding-right: 43px;
          line-height: 50px;
          color: #5F616C;
        }

        td:nth-child(2),
        td:nth-child(4) {
          height: 50px;
          line-height: 50px;
          padding-left: 33px;
          border: 1px solid #F3F3F3;
          color: #00112B;
        }
      }
    }
  }
}
</style>
